// extracted by mini-css-extract-plugin
export default {"staticMapWrapper":"styles_staticMapWrapper__h4BXe","staticMap":"styles_staticMap__6bFEh"};